var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmallChartPanel',{staticClass:"treemap-area-without-auto-filtered",attrs:{"title":_vm.title}},[_c('Treemap',{staticClass:"mt-2",staticStyle:{"max-height":"360px","width":"100%"},attrs:{"data":_vm.data,"height":"320"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }